import { render, staticRenderFns } from "./SitesView.vue?vue&type=template&id=27dd0c34&"
import script from "./SitesView.vue?vue&type=script&lang=js&"
export * from "./SitesView.vue?vue&type=script&lang=js&"
import style0 from "./SitesView.vue?vue&type=style&index=0&id=27dd0c34&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports